import { useCallback } from "react";
import {
  extractTokenUsage,
  getSessionLimitMessage,
  isSessionLimitError,
  isSessionLimitReached,
} from "../utils/sessionLimit";

export const useSessionLimitEnforcement = () => {
  const detectSessionLimitFromResponse = useCallback((response) => {
    if (!response || typeof response !== "object") return null;

    if (isSessionLimitError(response)) {
      return extractTokenUsage(response) || { blocked: true };
    }

    const tokenUsage = extractTokenUsage(response);
    if (!tokenUsage) return null;
    return isSessionLimitReached(tokenUsage) ? tokenUsage : null;
  }, []);

  const detectSessionLimitFromStreamError = useCallback((event, data) => {
    if (event === "blocked") {
      return {
        isBlocked: true,
        error: data?.error || "SESSION_LIMIT_REACHED",
        message: getSessionLimitMessage(data),
        token_usage: extractTokenUsage(data) || data?.token_usage || null,
      };
    }
    return null;
  }, []);

  const handleSessionLimitReached = useCallback(
    (reason = "Session limit reached. Please start a new session to continue.") => {
      // Intentionally no popup/modal. The page UI handles the blocked state
      // (inline warning + disabled send button).
      void reason;
    },
    [],
  );

  return {
    detectSessionLimitFromResponse,
    detectSessionLimitFromStreamError,
    handleSessionLimitReached,
  };
};
